import React, { useState } from 'react';
import { Menu, X, ChevronDown, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const [showIBDropdown, setShowIBDropdown] = useState(false);
  const [showInsightsDropdown, setShowInsightsDropdown] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-slate-950/90 backdrop-blur-xl border-b border-slate-800/50">
      <nav className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center">
            <img
              src="/images/logo.png"
              alt="Samvedanam Logo"
              className="h-8 md:h-9 w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-4">
            {/* About Us Dropdown */}
            <div className="relative group">
              <button className="text-slate-300 hover:text-amber-500 transition-colors text-[12px] font-medium flex items-center">
                About Us <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              <div className="absolute top-full left-0 mt-2 w-56 bg-slate-800 border border-slate-700 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                <a href="/#our-approach" className="block px-4 py-3 text-slate-300 hover:bg-slate-700 hover:text-amber-500 text-[12px]">Our Approach</a>
                <a href="/#our-team" className="block px-4 py-3 text-slate-300 hover:bg-slate-700 hover:text-amber-500 text-[12px]">Team</a>
                <a href="/careers" className="block px-4 py-3 text-slate-300 hover:bg-slate-700 hover:text-amber-500 text-[12px]">Careers</a>
              </div>
            </div>

            {/* Investment Banking Dropdown */}
            <div className="relative group">
              <button className="text-slate-300 hover:text-amber-500 transition-colors text-[12px] font-medium flex items-center">
                Investment Banking <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              <div className="absolute top-full left-0 mt-2 w-56 bg-slate-800 border border-slate-700 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                <a href="/investment-banking/fundraising" className="block px-4 py-3 text-slate-300 hover:bg-slate-700 hover:text-amber-500 text-[12px]">Fundraising</a>
                <a href="/investment-banking/mergers-acquisitions" className="block px-4 py-3 text-slate-300 hover:bg-slate-700 hover:text-amber-500 text-[12px]">Mergers & Acquisitions</a>
              </div>
            </div>

            <a href="/business-advisory" className="text-slate-300 hover:text-amber-500 transition-colors text-[12px] font-medium">Business Advisory</a>
            <a href="/#client-speak" className="text-slate-300 hover:text-amber-500 transition-colors text-[12px] font-medium">Testimonials</a>
            <a href="/live-deals" className="text-slate-300 hover:text-amber-500 transition-colors text-[12px] font-medium">Live Deals</a>
            <a href="/academy" className="text-slate-300 hover:text-amber-500 transition-colors text-[12px] font-medium">Academy</a>

            {/* Insights Dropdown */}
            <div className="relative group">
              <button className="text-slate-300 hover:text-amber-500 transition-colors text-[12px] font-medium flex items-center">
                Insights <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              <div className="absolute top-full left-0 mt-2 w-56 bg-slate-800 border border-slate-700 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                <a href="/blog" className="block px-4 py-3 text-slate-300 hover:bg-slate-700 hover:text-amber-500 text-[12px]">Blog</a>
                <a href="/reports" className="block px-4 py-3 text-slate-300 hover:bg-slate-700 hover:text-amber-500 text-[12px]">Our Reports</a>
                <a href="/podcasts" className="block px-4 py-3 text-slate-300 hover:bg-slate-700 hover:text-amber-500 text-[12px]">Podcasts</a>
              </div>
            </div>

            {/* <a href="/client-login">
              <Button className="bg-amber-600 hover:bg-amber-700 text-white">
                Client Login
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </a> */}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white"
            onClick={() => setShowMobileNav(!showMobileNav)}
          >
            {showMobileNav ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {showMobileNav && (
          <div className="lg:hidden mt-4 pb-4 space-y-2">
            <div>
              <button
                onClick={() => setShowAboutDropdown(!showAboutDropdown)}
                className="w-full text-left px-4 py-2 text-slate-300 hover:text-amber-500 flex items-center justify-between"
              >
                About Us <ChevronDown className={`h-4 w-4 transition-transform ${showAboutDropdown ? 'rotate-180' : ''}`} />
              </button>
              {showAboutDropdown && (
                <div className="pl-8 space-y-2">
                  <a href="/#our-approach" className="block py-2 text-slate-400 hover:text-amber-500">Our Approach</a>
                  <a href="/#our-team" className="block py-2 text-slate-400 hover:text-amber-500">Team</a>
                  <a href="/careers" className="block py-2 text-slate-400 hover:text-amber-500">Careers</a>
                </div>
              )}
            </div>

            <div>
              <button
                onClick={() => setShowIBDropdown(!showIBDropdown)}
                className="w-full text-left px-4 py-2 text-slate-300 hover:text-amber-500 flex items-center justify-between"
              >
                Investment Banking <ChevronDown className={`h-4 w-4 transition-transform ${showIBDropdown ? 'rotate-180' : ''}`} />
              </button>
              {showIBDropdown && (
                <div className="pl-8 space-y-2">
                  <a href="/investment-banking/fundraising" className="block py-2 text-slate-400 hover:text-amber-500">Fundraising</a>
                  <a href="/investment-banking/mergers-acquisitions" className="block py-2 text-slate-400 hover:text-amber-500">Mergers & Acquisitions</a>
                </div>
              )}
            </div>

            <a href="/business-advisory" className="block px-4 py-2 text-slate-300 hover:text-amber-500">Business Advisory</a>
            <a href="/#client-speak" className="block px-4 py-2 text-slate-300 hover:text-amber-500">Client Speak</a>
            <a href="/live-deals" className="block px-4 py-2 text-slate-300 hover:text-amber-500">Live Deals</a>
            <a href="/academy" className="block px-4 py-2 text-slate-300 hover:text-amber-500">Academy</a>

            <div>
              <button
                onClick={() => setShowInsightsDropdown(!showInsightsDropdown)}
                className="w-full text-left px-4 py-2 text-slate-300 hover:text-amber-500 flex items-center justify-between"
              >
                Insights <ChevronDown className={`h-4 w-4 transition-transform ${showInsightsDropdown ? 'rotate-180' : ''}`} />
              </button>
              {showInsightsDropdown && (
                <div className="pl-8 space-y-2">
                  <a href="/blog" className="block py-2 text-slate-400 hover:text-amber-500">Blog</a>
                  <a href="/reports" className="block py-2 text-slate-400 hover:text-amber-500">Our Reports</a>
                  <a href="/podcasts" className="block py-2 text-slate-400 hover:text-amber-500">Podcasts</a>
                </div>
              )}
            </div>

            {/* <a href="/client-login" className="block px-4 py-2">
              <Button className="w-full bg-amber-600 hover:bg-amber-700 text-white">
                Client Login
              </Button>
            </a> */}
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
